import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const STORAGE_KEY = 'melodiza:player';

export const usePlayerStore = create(
  persist(
    (set, get) => ({
      // state
      currentTrack: null,
      isPlaying: false,
      playlist: [],
      currentTrackIndex: 0,
      currentTime: 0,
      duration: 0,
      volume: 0.7,

      // actions
      setCurrentTrack: (t) => set({ currentTrack: t }),
      setIsPlaying: (v) =>
        set({ isPlaying: typeof v === 'function' ? v(get().isPlaying) : v }),
      setPlaylist: (list) => set({ playlist: list }),
      setCurrentTrackIndex: (i) => set({ currentTrackIndex: i }),
      setCurrentTime: (t) => set({ currentTime: t }),
      setDuration: (d) => set({ duration: d }),
      setVolume: (v) =>
        set({ volume: typeof v === 'function' ? v(get().volume) : v }),

      playTrack: (track, trackList, index) => {
        const list =
          Array.isArray(trackList) && trackList.length > 0
            ? trackList
            : [track];
        const safeIndex =
          typeof index === 'number' && index >= 0 && index < list.length
            ? index
            : 0;
        set({
          currentTrack: track,
          playlist: list,
          currentTrackIndex: safeIndex,
          isPlaying: true,
        });
      },

      // multi-tenant safety
      resetPlayerStore: () =>
        set({
          currentTrack: null,
          isPlaying: false,
          playlist: [],
          currentTrackIndex: 0,
          currentTime: 0,
          duration: 0,
          volume: 0.7,
        }),
    }),
    {
      name: STORAGE_KEY,
      partialize: (s) => ({
        // Persist track context, NOT isPlaying (always false on reload)
        currentTrack: s.currentTrack,
        playlist: s.playlist,
        currentTrackIndex: s.currentTrackIndex,
        currentTime: s.currentTime,
        volume: s.volume,
      }),
      // Defense-in-depth: force isPlaying=false on rehydrate, and clamp
      // currentTrackIndex to a valid position within the persisted playlist.
      // This prevents stale persisted state (e.g. an old single-track collapse
      // or a playlist truncated since last session) from breaking next/prev.
      onRehydrateStorage: () => (state) => {
        if (!state) return;
        state.isPlaying = false;
        const len = Array.isArray(state.playlist) ? state.playlist.length : 0;
        if (len === 0) {
          state.currentTrackIndex = 0;
        } else if (
          typeof state.currentTrackIndex !== 'number' ||
          state.currentTrackIndex < 0 ||
          state.currentTrackIndex >= len
        ) {
          state.currentTrackIndex = 0;
        }
        // If currentTrack is set but not in playlist, ensure currentTrack matches the index.
        if (len > 0 && state.playlist[state.currentTrackIndex]) {
          state.currentTrack = state.playlist[state.currentTrackIndex];
        }
      },
    }
  )
);
